import { render, staticRenderFns } from "./SetTambahResult.vue?vue&type=template&id=11216b2c&"
import script from "./SetTambahResult.vue?vue&type=script&lang=js&"
export * from "./SetTambahResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports